import { useLocalObservable } from 'mobx-react-lite';
import { ElementType } from 'react';

import { Call } from '@gem/call/CallStore/Call';
import { useCallContext } from '@gem/call/CallView/CallView.context';
import { IWaitingRoomMember, WaitingRoomRequestStatus } from '@gem/call/Model/callModel.types';
import { IcClose24Icon, IcDoneIcon } from '@gem/icons';

interface IWaitingRoomMemberCardActions {
  key: string;
  icon: ElementType;
  onClick(): void;
}

interface IWaitingRoomMemberCardPresenter {
  call: Call;
  actions: IWaitingRoomMemberCardActions[];
  rejectMember(): void;
  approveMember(): void;
}

export const useWaitingRoomMemberCardPresenter = (
  member: IWaitingRoomMember
): IWaitingRoomMemberCardPresenter => {
  const context = useCallContext();

  const presenter = useLocalObservable<IWaitingRoomMemberCardPresenter>(() => ({
    get call(): Call {
      return context.call;
    },

    approveMember(): void {
      context.callController.updateWaitingRoomForMember(
        member.memberId,
        WaitingRoomRequestStatus.Approve
      );
    },

    rejectMember(): void {
      context.callController.updateWaitingRoomForMember(
        member.memberId,
        WaitingRoomRequestStatus.Reject
      );
    },

    get actions(): IWaitingRoomMemberCardActions[] {
      return [
        {
          key: 'reject',
          icon: IcClose24Icon,
          onClick: presenter.rejectMember,
        },
        {
          key: 'approve',
          icon: IcDoneIcon,
          onClick: presenter.approveMember,
        },
      ];
    },
  }));

  return presenter;
};
